import { render, staticRenderFns } from "./PageHeadingFullScreen.vue?vue&type=template&id=35c7a863&scoped=true&"
import script from "./PageHeadingFullScreen.vue?vue&type=script&lang=js&"
export * from "./PageHeadingFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadingFullScreen.vue?vue&type=style&index=0&id=35c7a863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7a863",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
